import DAT from "dat-gui";

const INSTANCING   = true;

const DEBUG        = false;
const DEBUG_CAMERA = false;


// perf profile => 0:sd | 1:md | 2:hd
let profile = 2; 
// force profile 0 for small screens (expected to be mobile devices) to uses forward rendering
if (window.innerWidth < 768) {
    profile = 0
}

export function getProfile() {
    return params.profile;
}

var params = {
    debugCamera:               DEBUG_CAMERA,
    debug:                     DEBUG,
    useDraco:                  true,
    useInstancing:             INSTANCING,
    useEditor:                 true,
    profile,
    useDerivative:             true,// for normal maps
    useAlpha:                  true,
    useReflectionProbe:        true,
    reflectionProbeResolution: 2048,
    reflectionProbeTileSize:   512,
    useSingleMesh: false,
    cloudsBeforeTAA: false,
    usePlayerCamera: true,
    useLongHistory: false,
    useVariance: false,
    autoNeighbourgClipping:    true,
    compareUniforms:   false,
    compareAttributes: false,
    //INSTANCING
    minInstances: 2,//min of instances to actually use instacing for a mesh
    uCloudsOffset: 1000.,//cloud Y position
    backfaceCulling: true,
    useVignetting: true,
    gammaCorrection: true,
    usePostGammaCorrection: false,
    numLights: 1,
    useAtrouNormal: true,
    useUnjitterLast: false,
    useUnjitterDepth: false,
    neighbourgClippingOffset: 2,
    uVarianceClippingGamma:   2,
    TAASpatialThreshold: 5,
    sceneDownscale: 1,
    forceShadows: false,
    usePoisonDiskJitter: false,
    updateIBL: false,
    uSSStepMulitplier: 1.05,
    useSSDownscale: false,
    uSSRClamp: false,
    uSSGIClamp: false,
    useLowDepth:  false,//profile <= 3 ? false : true,
    useLowDirect: false,//profile <= 3 ? false : true,
    bilateralBlurIterations: 2,//profile <= 2 ? 0 : 5,//generic ?maybe useless now
    LOD: 0,//profile <= 1 ? 10 : 0,
    useHDR: true,
    useNDV: false,
    useFirstPerson: true,
    useRandomColor: false,
    updateShadows: false,
    useFresnelSchlickRoughness: true,
    wheatMesh:                 'SM_Wheat',
    useSMAA:                   false,//profile <= (EXTRA_PERF_BOOST ? 1 : -1) ? true : false,//profile <= 2 ? false : true,
    uSharpenStrength:          0.25,// profile <= (EXTRA_PERF_BOOST ? 1 : 0) ? 0.45 : 0.25,
    TAATemporalThreshold:      0.9,// profile <= (EXTRA_PERF_BOOST ? 1 : -1) ? 0.7 : 0.9,  

    /** Bloom */
    uBloomBlur:  4.4,
    uBloomAmount: 0.24,
    uBloomThreshold: 1,

    /** Antialiasing */
    uSMAAThreshold: 0.01,
    showSMAAEdges: false,
    temporalOffsetCamera: false,

    /** Resolution */
    devicePixelRatio:      1,//window.devicePixelRatio,
    depthDevicePixelRatio: 1,//window.devicePixelRatio,
    resolution:            [window.innerWidth, window.innerHeight],

    /** Camera */
    fov: 45,
    focalLength:    2.400001,
    cameraFar: 8000.,
    cameraNear: 1,

    /** Temporal Noise Filter */
    animateNoise: true,
    uBestCandidate: false,
    uBestCandidateThreshold: 0.001,
    uTemporalThreshold: 0.98,
    uSpatialThreshold: 30,//0.0007,
    uDepthThreshold: 0.005,
    uNormalThreshold: 0.2,//.9,
    uLumaThreshold: 0.276,
    uErrorThreshold: 0.75,
    uAgeThreshold: 1.,
    uClear: true,

    /** Bilateral Blur filter */
    bilateralBlurMethod: 1,
    postTemporalAtrouFilter: true,
    useAtrouNoiseFilter: /*DEBUG ? false : */true,

    /** A-trou */
    uAtrouColorThreshold: 1,
    uAtrouNormalThreshold: 0.5,
    uAtrouPositionThreshold: 2000,
    uAtrouDepthThreshold: 0.0000001,
    uAtrouLuminanceThreshold: 1,

    /** IBL */
    useIBL: /*DEBUG ? false : */true,
    uIBLDiffRoughness: 1.0,
    uIBLSpecRoughness: 0.,
    exposition:   1,
    envRotationX: 0,
    envRotationY: 0,
    envRotationZ: 0,
    useBakedLighting: true,
    IBLResolution:             [64, 32],

    /**SHADOWS */
    useShadows: true,
    uPoisonDisk: [-0.94201624, -0.39906216 , 0.94558609, -0.76890725 , -0.094184101, -0.92938870 , 0.34495938, 0.29387760 , -0.91588581, 0.45771432 , -0.81544232, -0.87912464 , -0.38277543, 0.27676845 , 0.97484398, 0.75648379 , 0.44323325, -0.97511554 , 0.53742981, -0.47373420 , -0.26496911, -0.41893023 , 0.79197514, 0.19090188 , -0.24188840, 0.99706507 , -0.81409955, 0.91437590 , 0.19984126, 0.78641367 , 0.14383161, -0.14100790],
    shadowCameraMaxAngle: 0.9,
    uShadowBias: 0.00005,//profile==0 ? 0.0005 : 0.0003,
    uShadowMix: 1.,
    uShadowBlur: 0.001,
    uSearchWidth: 1.,
    uNearPleane: 1,//AUTOMATE THIS !
    uLightSize: 0.3,//AUTOMATE THIS
    uShadowMapResolution:      2048,
    uShadowMapTileSize:        512,
    uShadowMapCenterTileSize:  256,

    /** Light */
    lightX: 62,
    lightY: 40.,
    lightZ: -10,
    lightIntensity: 1,
    lightAngle: 0.5,//Math.PI/20,

    /** SAMPLING */
    samplingMethod: 1,//0==random | 1==cosineweighted | 5==bluenoise
    blueNoiseSamplingMethod: 5,//1==random, 5 == BNDS

    /**SS General */
    SSDirectScale:   1,
    uSSRBias:        0.00001,
    uAODist:         2000,//0.35,
    uSSRMaxDist:               10000,
    uSSRMaxDrawDist: 100000,
    SSGIScale: 1,
    SSAOScale: 1,
    SSRScale:  1,
    SSGIBlurIterations:  5,
    SSAOBlurIterations:  1,

    /**SSR */
    uSSRStart:   20,
    uSSRStep:    20,
    uSSRDist:    20,
    uSSRSteps:   30,
    SSRBlurIterations:  0,

    /**SSAO */
    uSSAOStart:    3,
    uSSAOStep:     3,
    uSSAODist:     3,
    uSSAOSteps:    30,
    uSSAOSamples:  1,
    uSSAOMult:     1,//increase AO contrasts
    uSSAODistMult: 30,//multiple start,dist and step based on distance

    /** Old ScreenSpace AO */
    SSAORadius: 0.66,
    SSAORange: 0.004,
    SSAOBias: 0.0001,

    /**SSGI */
    uSSGIStart:         5,
    uSSGIStep:          100,
    uSSGIDist:          100,
    uSSGISteps:         30,
    uSSGISamples:       1,
    uSSGIMult:          1,

    /**SS Shadow */
    useSSShadow:    false,
    uSSShadowDist:  20,
    uSSShadowSteps: 0,
    uSSShadowStep:  20,
    uSSShadowStart: 30,
    useCenterShadows: true,

    /** PBR */
    uAreaLightIntensity: 0.7,

    /** SKY */
    uSkyEyeHeight: 10,
    skyResolution: [256, 128],
    skyMode: 3,
    uSunPositionX: -0.44,
    uSunPositionY: 0.155,
    uSunPositionZ: 0,
    uSunScatterMax: 0.9,
    uSunScatterStep: 0.25,
    uCloudExtinction: 0.03,
    uSunDecay: 2.4,
    uSunIntensity: 10000,
    uSpotlightIntensity: 10000,
    uSunAngle: 0.98,//0.92,

    /** CLOUDS OLD */
    uLightStepSize:  0.5,  // 0.1,
    uCloudsStepSize: 1.5, // 0.07,
    uCloudSunIntensity: 0.8,
    uCloudsLightAbsorptionTowardSun: 1.36,
    uLightAbsorptionThroughCloud: 0.85,
    uCloudsDarknessThreshold: 0.075,
    uCloudCoverage: 0.35,//0.45,
    uCloudCoverageSmoothing: .025,
    uWorleyScale0: 0.0212242,//0.035,//.0212242,

    // CLOUDS COMMON
    uCloudsMult: 0.015,//0.0212242,
    useVoxelClouds: false,
    uCloudsforwardScattering: 0.89,
    uCloudsbackScattering: 0.5,
    uPowderCoef: 1.2,
    uCloudsbaseBrightness: 1. ,
    uCloudsCloudsphaseFactor: 0.85,
    uWorleyTextureScale0: 4.,
    uWorleyTextureScale1: 8.,
    uWorleyTextureScale2: 16.,
    uWorleyLvl0: 1.,
    uWorleyLvl1: 0.25,
    uWorleyLvl2: 0.125,
    uWorleyLvl3: 0.08,//TODO: check with 0.0625
    uCloudsDownscale: 0.01,// : 0.02,
    uCloudsCenter: [0., 800., 0.],//0.,5000.,0.
    uCloudVoxelsPerSide: [256.,256.],
    uCloudVoxelResolution: [4096,4096],




    /* VOXELS */
    useVoxels:       true,
    voxelSceneSize:  1500,
    voxelResolution: [512, 512],
    voxelsPerSide:   64,
    voxelFaceExpand: 0.5,
    voxelThinTriangleExpand: 0.5,
    voxelMerge: 0.5,

    /** DOF */
    useDOF: false,//profile <= 1 ? false : true,
    uBokehRadius: 2.0,
    uBokehAmount: 2,
    uBokehThreshold: 0.01005,
    uFocalDistance: 0.6005,
    uAperture: 2.5,

    /** TONE MAPPING */
    gammaCorrection: true,
    useACESFilmToneMapping: false,
    useUncharted2ToneMapping: false,
    useReinhardToneMapping: false,
    useUE4ToneMapping: false,
    useUE3ToneMapping: false,
    uACESExpCompensation: 1.4,

    /** FILMIC GRAIN */
    uFilmGrainAmount: 0.04,
    
    /** COLOR CORRECTION */
    useColorCorrection: true,
    uBrightness:0,
    uContrast: 1,
    uSaturation: 1,
    uRed:   0.5,
    uGreen: 0.5,
    uBlue:  0.5,
    
    /* Exponential Fog */
    useFog: false,
    uFogHeightFalloff: 0.0001,
    uFogDensity: 0.00003,//0.00001,

}

export function updateProfile(params, profile) {
    
    // console.log('UPDATE_PROFILE', profile);
    
    let profileParams = {

        profile,
        
        //SD
        isMobile:                  profile == 0 ? true : false,
        forwardRendering:          profile <= 0 ? true : false,
        deferedRendering:          profile <= 0 ? false : true,
        useSSDirect:               profile <= 0 ? false : true,
        uSkipDirect: false,
        renderScale:               profile <= 0 ? 1 : 0.5,//when in SD, try to render at full scale as we dont use TAA
        IBLDiffuseMix:             profile <= 0 ? 0.5 : 0.17,
        IBLSpecularMix:            profile <= 0 ? 1 :  0.5,
        useShadowNoise:            profile <= 0 ? false : true,
        useTemporalAA:             profile <= 0 ? false : true,
        useTemporalJitter:         profile <= 0 ? false : true,
        useUnjitter:               profile <= 0 ? false : true,
        useNeighbourgClipping:     profile <= 0 ? false : true,
        canNeighbourgClipping:     profile <= 0 ? false : true,
        useTemporalUpscale:        profile <= 0 ? false : true,
        
        //MD
        useClouds:                 profile <= 1 ? false : true,
        mipmapBias:                profile <= 1 ? 0 : -2,//increase texture details
        useSharpen:                profile <= 1 ? false : true,
        useACESFitted:             profile <= 1 ? false : true,//profile <= (-1) ? false : true,
        usePostToneMapping:        profile <= 1 ? true : false,//tonemaping direclty in final pass
        useTemporalNoiseFilter:    profile <= 1 ? false : true,
        
        //HD
        useAreaLights:             profile <= 2 ? false : true,
        historyClippingMethod:     profile <= 2 ? 2 : 3, //0: 3x3 RGB, 1: 3x3 Luma, 2: 2x2 BBox, 3: 2x2 Variance, 4: 3x3 & '+'
        useBetterTextureSampling:  profile <= 2 ? false : true,
        useSoftShadows:            profile <= 2 ? false : true,
        canCenterShadows:          profile <= 2 ? false : true,
        cloudMult:                 profile <= 2 ? 0.25 : 0.5,
        textureResolution:         profile <= 2 ? '512' : '1024',//we dont actually use 2048 excpet for homepage
        uCloudsMaxSteps:           profile <= 2 ? 4 : 10,
        useCloudsAndParticles:     profile <= 2 ? false : true,//for operation room as cloud+wheat is too much for SD mode
        numWheatParticles:         profile <= 2 ? 10000 : 40000,
        maxWheatDistance:          profile <= 2 ? (20000) : 35000,
        useChromaticAberration:    profile <= 2 ? false : true,
        useFilmGrain:              profile <= 2 ? false : true,
        useSSGI:                   profile <= 2 ? false : true,
        useSSR:                    profile <= 2 ? false : true,
        useSSAO:                   profile <= 2 ? false : true,
        useBloom:                  profile <= 2 ? false : true,

    }
    for (let k in profileParams) {
        params[k] = profileParams[k]
    }
    return params;
}





// let guiOptions = {
//     'Quick Acces':                   {type: 'separator' },


//     useEditor:                       {type: 'boolean' },
//     useSMAA:                         {type: 'boolean' },
//     useLongHistory:                  {type: 'boolean'},
//     useVariance:                     {type: 'boolean'},
//     autoNeighbourgClipping:          {type: 'boolean'},
//     usePostGammaCorrection:          {type: 'boolean'},
//     useVignetting:                   {type: 'boolean'},
//     useBetterTextureSampling:        {type: 'boolean'},
//     useTemporalUpscale:              {type: 'boolean' },
//     useNeighbourgClipping:           {type: 'boolean' },
//     focalLength:                     {type: 'number', min: 0, max:4.0, step: 0.00001 },
//     useAtrouNormal:                  {type: 'boolean' },
//     uFilmGrainAmount:                {type: 'number',min: 0, max: 1, step: 0.0001},
//     neighbourgClippingOffset:        {type: 'number',min: 0, max: 10, step: 0.5},
//     TAASpatialThreshold:             {type: 'number',min: 0, max: 5000, step: 0.1},
//     historyClippingMethod:           {type: 'number',min: 0, max: 4, step: 1},
//     uVarianceClippingGamma:          {type: 'number',min: 0, max: 10, step: 0.1},
//     useChromaticAberration:          {type: 'boolean' },
//     usePoisonDiskJitter:             {type: 'boolean' },
//     useUnjitter:                     {type: 'boolean' },
//     useUnjitterDepth:                {type: 'boolean' },
//     useUnjitterLast:                 {type: 'boolean' },
//     useSharpen:                      {type: 'boolean' },
//     uSharpenStrength:                {type: 'number',min: 0, max: 1, step: 0.001},
//     useTemporalAA:                   {type: 'boolean' },
//     useTemporalJitter:               {type: 'boolean' },
//     renderScale:                     {type: 'number',min: 0, max: 1, step: 0.1, onChange: ()=>{ window.dispatchEvent(new Event('resize')); } },
//     useSSDownscale:                  {type: 'boolean', onChange: ()=>{ window.dispatchEvent(new Event('resize')); } },
//     useLowDepth:                     {type: 'boolean' },
//     useLowDirect:                    {type: 'boolean' },
//     useTemporalNoiseFilter:          {type: 'boolean' },
//     useAtrouNoiseFilter:             {type: 'boolean' },
//     uSkipDirect:                     {type: 'boolean' },
//     useSSDirect:                     {type: 'boolean' },
//     useSSR:                          {type: 'boolean' },
//     useSSGI:                         {type: 'boolean' },
//     useSSAO:                         {type: 'boolean' },
//     backfaceCulling:                 {type: 'boolean' },
//     uSpotlightIntensity:             {type: 'number', min: 0, max: 100000, step: 0.0001 },
//     useSSShadow:                     {type: 'boolean' },
//     ////////////////////////////////////////////
//     'Voxels':                        {type: 'separator' },
//     voxelFaceExpand:                 {type: 'number', min: 0, max: 1, step: 0.001 },
//     voxelThinTriangleExpand:         {type: 'number', min: 0, max: 1, step: 0.001 },
//     voxelSceneSize:                  {type: 'number', min: 0, max: 5000, step: 0.5 },
//     voxelMerge:                      {type: 'number', min: 0, max: 1, step: 0.001 },
//     ////////////////////////////////////////////
//     'IBL':                           {type: 'separator' },
//     useIBL:                          {type: 'boolean' },
//     IBLDiffuseMix:                   {type: 'number', min: 0, max: 1, step: 0.001 },
//     IBLSpecularMix:                  {type: 'number', min: 0, max: 1, step: 0.001 },
//     useHDR:                          {type: 'boolean' },
//     envRotationX:                    {type: 'number', min: -Math.PI, max: Math.PI, step: 0.001 },
//     envRotationY:                    {type: 'number', min: -Math.PI, max: Math.PI, step: 0.001 },
//     envRotationZ:                    {type: 'number', min: -Math.PI, max: Math.PI, step: 0.001 },
//     ////////////////////////////////////////////
//     'SKY':                           {type: 'separator' },
//     updateIBL:                       {type: 'boolean' },
//     uSunIntensity:                   {type: 'number', min: 0, max: 100000, step: 0.0001 },
//     uSunAngle:                       {type: 'number', min: 0, max: (Math.PI/2)*0.999, step: 0.001 },
//     exposition:                      {type: 'number', min: 0, max: 10, step: 0.001 },
//     skyMode:                         {type: 'number', min: 0, max: 3, step: 1 },
//     uSunDecay:                       {type: 'number', min: 0, max: 20, step: 0.0001 },
//     uSunPositionX:                   {type: 'number', min: -1, max: 1, step: 0.001 },
//     uSunPositionY:                   {type: 'number', min: -1, max: 1, step: 0.00001 },
//     uSunPositionZ:                   {type: 'number', min: -3000, max: 3000, step: 0.0001 },
//     uSkyEyeHeight:                   {type: 'number', min: 0, max: 10000, step: 1 },
//     ////////////////////////////////////////////
//     'FOG':                           {type: 'separator' },
//     useFog:                          {type: 'boolean' },
//     uFogHeightFalloff:               {type: 'number', min: 0, max: 0.5, step: 0.000001 },
//     uFogDensity:                     {type: 'number', min: 0, max: 0.5, step: 0.000001 },
//     ////////////////////////////////////////////
//     'Clouds':                        {type: 'separator' },
//     useClouds:                       {type: 'boolean' },
//     uCloudsOffset:                   {type:'number',min: 0, max: 1000, step: 0.0001},
//     uCloudsMult:                     {type: 'number', min: 0, max: 2, step: 0.00001 },
//     uCloudCoverageSmoothing:         {type: 'number', min: 0, max: 1, step: 0.00001 },
//     uCloudsMaxSteps:                 {type: 'number', min: 0, max: 100, step: 0.00001 },
//     useVoxelClouds:                  {type: 'boolean' },
//     uCloudSunIntensity:              {type: 'number', min: 0, max: 2, step: 0.00001 },
//     uCloudsLightAbsorptionTowardSun: {type: 'number', min: 0, max: 2, step: 0.00001 },
//     uLightAbsorptionThroughCloud:    {type: 'number', min: 0, max: 2, step: 0.00001 },
//     uCloudsDarknessThreshold:        {type: 'number', min: 0, max: 2, step: 0.00001 },
//     uCloudsforwardScattering:        {type: 'number', min: 0, max: 2, step: 0.00001 },
//     uCloudsbackScattering:           {type: 'number', min: 0, max: 2, step: 0.00001 },
//     uPowderCoef:                     {type: 'number', min: 0, max: 2, step: 0.00001 },
//     uCloudsbaseBrightness:           {type: 'number', min: 0, max: 2, step: 0.00001 },
//     uCloudsCloudsphaseFactor:        {type: 'number', min: 0, max: 2, step: 0.00001 },
//     uLightStepSize:                  {type: 'number', min: 0, max: 100, step: 0.00001 },
//     uCloudsStepSize:                 {type: 'number', min: 0, max: 100, step: 0.00001 },
//     uCloudCoverage:                  {type: 'number', min: 0, max: 2, step: 0.00001 },
//     uWorleyTextureScale0:            {type: 'number', min: 0, max: 32, step: 0.00001 },
//     uWorleyTextureScale1:            {type: 'number', min: 0, max: 32, step: 0.00001 },
//     uWorleyTextureScale2:            {type: 'number', min: 0, max: 32, step: 0.00001 },
//     uWorleyLvl0:                     {type: 'number', min: 0, max: 2, step: 0.00001 },
//     uWorleyLvl1:                     {type: 'number', min: 0, max: 2, step: 0.00001 },
//     uWorleyLvl2:                     {type: 'number', min: 0, max: 2, step: 0.00001 },
//     uWorleyLvl3:                     {type: 'number', min: 0, max: 2, step: 0.00001 },
//     ////////////////////////////////////////////
//     'Bloom':                         {type: 'separator' },
//     useBloom:                        {type: 'boolean' },
//     uBloomBlur:                      {type: 'number', min: 0, max: 10, step: 0.000001 },
//     uBloomAmount:                    {type: 'number', min: 0, max: 4, step: 0.000001 },
//     uBloomThreshold:                 {type: 'number', min: 0, max: 4, step: 0.000001 },
//     ////////////////////////////////////////////
//     'Shadows':                       {type: 'separator' },
//     forceShadows:                    {type: 'boolean' },
//     useSoftShadows:                  {type: 'boolean' },
//     useShadows:                      {type: 'boolean' },
//     useCenterShadows:                {type: 'boolean' },
//     updateShadows:                   {type: 'boolean' },
//     useShadowNoise:                  {type: 'boolean' },
//     uLightSize:                      {type: 'number', min: 0, max: 1000000, step: 0.00001 },
//     uShadowBias:                     {type: 'number', min: 0, max: 0.1, step: 0.00001 },
//     uShadowMix:                      {type: 'number', min: 0, max: 1, step: 0.00001 },
//     uShadowBlur:                     {type: 'number', min: 0, max: 0.1, step: 0.00001 },
//     ////////////////////////////////////////////
//     'AREA LIGHTS':                   {type: 'separator' },
//     useAreaLights:                   {type: 'boolean' },
//     uAreaLightIntensity:             {type: 'number', min: 0, max: 2, step: 0.000001 },
//     ////////////////////////////////////////////
//     'Screen Space (General)':        {type: 'separator' },
//     uSSStepMulitplier:               {type: 'number', min: 0, max: 3, step: 0.00001 },
//     uSSRClamp:                       {type: 'boolean' },
//     uSSGIClamp:                      {type: 'boolean' },
//     uSSRBias:                        {type: 'number', min: 0, max: 0.01, step: 0.00001 },
//     uSSRMaxDist:                     {type: 'number', min: 0, max: 100000, step: 0.0001 },
//     uSSRMaxDrawDist:                 {type: 'number', min: 0, max: 100000, step: 0.0001 },
//     ////////////////////////////////////////////
//     'Screen Space Reflections':      {type: 'separator' },
//     uSSRStart:                       {type: 'number', min: 0, max: 1000, step: 1 },
//     uSSRStep:                        {type: 'number', min: 0, max: 200, step: 0.00001 },
//     uSSRDist:                        {type: 'number', min: 0, max: 200, step: 0.00001 },
//     uSSRSteps:                       {type: 'number', min: 1, max:200.0, step: 1 },
//     SSRBlurIterations:               {type: 'number', min: 0, max: 7, step: 1 },
//     ////////////////////////////////////////////
//     'Screen Space AO':               {type: 'separator' },
//     uSSAOStart:                      {type: 'number', min: 0, max:20000, step: 0.00001 },
//     uSSAOStep:                       {type: 'number', min: 0, max: 200, step: 0.00001 },
//     uSSAODist:                       {type: 'number', min: 0, max: 200, step: 0.00001 },
//     uSSAOSteps:                      {type: 'number', min: 0, max:200.0, step: 1 },
//     uSSAOSamples:                    {type: 'number', min: 0, max:200.0, step: 1 },
//     SSAOBlurIterations:              {type: 'number', min: 0, max: 7, step: 1 },
//     uSSAODistMult:                   {type: 'number', min: 0, max: 20, step: 0.0001 },
//     uSSAOMult:                       {type: 'number', min: 0, max:3, step: 0.00001 },
//     uAODist:                         {type: 'number', min: 0, max:20000, step: 0.00001 },
//     ////////////////////////////////////////////
//     'Screen Space GI':               {type: 'separator' },
//     uSSGIStart:                      {type: 'number', min: 0, max: 1000, step: 1 },
//     uSSGIStep:                       {type: 'number', min: 0, max: 200, step: 0.00001 },
//     uSSGIDist:                       {type: 'number', min: 0, max: 200, step: 0.00001 },
//     uSSGISteps:                      {type: 'number', min: 0, max:200.0, step: 1 },
//     uSSGISamples:                    {type: 'number', min: 0, max:200.0, step: 1 },
//     SSGIBlurIterations:              {type: 'number', min: 0, max: 7, step: 1 },
//     uSSGIMult:                       {type: 'number', min: 0, max:4.0, step: 0.00001 },

//     'Screen Space Shadows':          {type: 'separator' },
//     uSSShadowDist:                   {type: 'number', min: 0, max: 1000, step: 0.00001 },
//     uSSShadowSteps:                  {type: 'number', min: 0, max:200.0, step: 1 },
//     uSSShadowStep:                   {type: 'number', min: 0, max: 200, step: 0.00001 },
//     uSSShadowStart:                  {type: 'number', min: 0, max: 1000, step: 1 },

//     'SMAA':                          {type: 'separator' },
//     uSMAAThreshold:                  {type: 'number', min: 0, max: 1, step: 0.00001 },
//     showSMAAEdges:                   {type: 'boolean' },
//     temporalOffsetCamera:            {type: 'boolean' },

//     'Sampling':                      {type: 'separator' },
//     samplingMethod:                  {type: 'number', min: 0, max: 10, step: 1 },
//     animateNoise:                    {type: 'boolean' },
//     blueNoiseSamplingMethod:         {type: 'number', min: 0, max: 10, step: 1 },

//     'Temporal + A-trou':             {type: 'separator' },
//     uClear:                          {type: 'boolean' },
//     postTemporalAtrouFilter:         {type: 'boolean' },
//     bilateralBlurMethod:             {type: 'number', min: 0, max: 5, step: 1 },
//     bilateralBlurIterations:         {type: 'number', min: 0, max: 20, step: 1 },
//     uTemporalThreshold:              {type: 'number', min: 0.0001, max: 0.999, step: 0.000001 },
//     uLumaThreshold:                  {type: 'number', min: 0, max: 1.2, step: 0.0001 },
//     uNormalThreshold:                {type: 'number', min: -1, max: 1., step: 0.00000001 },
//     uSpatialThreshold:               {type: 'number', min: 0, max: 1000, step: 1 },
//     uDepthThreshold:                 {type: 'number', min: 0.00005, max: 0.005, step: 0.00001 },
//     uAtrouColorThreshold:            {type: 'number', min: 0.0000001, max: 1.0000001, step: 0.0000001 },
//     uAtrouNormalThreshold:           {type: 'number', min: 0.0000001, max: 1.0000001, step: 0.0000001 },
//     uAtrouPositionThreshold:         {type: 'number', min: 0.0000001, max: 4000.0000001, step: 0.0000001 },
//     uAtrouDepthThreshold:            {type: 'number', min: 0.0000001, max: 0.00001, step: 0.0000001 },
//     uAtrouLuminanceThreshold:        {type: 'number', min: 0.0000001, max: 1.0000001, step: 0.0000001 },

//     'Tone Mapping':                  {type: 'separator' },
//     gammaCorrection:                 {type: 'boolean' },
//     useReinhardToneMapping:          {type: 'boolean' },
//     useUncharted2ToneMapping:        {type: 'boolean' },
//     useUE4ToneMapping:               {type: 'boolean' },
//     useACESFilmToneMapping:          {type: 'boolean' },
//     useUE3ToneMapping:               {type: 'boolean' },
//     useACESFitted:                   {type: 'boolean' },
//     uACESExpCompensation:            {type: 'number',min: 0, max: 5, step: 0.001},

//     'Color Correction':              {type: 'separator' },
//     useColorCorrection:              {type: 'boolean'},
//     uBrightness:                     {type: 'number',min: 0, max: 1, step: 0.001},
//     uContrast:                       {type:'number',min: 1, max: 2, step: 0.001},
//     uSaturation:                     {type:'number',min: -1, max: 2, step: 0.001},
//     uRed:                            {type:'number',min: 0, max: 1, step: 0.001},
//     uGreen:                          {type:'number',min: 0, max: 1, step: 0.001},
//     uBlue:                           {type:'number',min: 0, max: 1, step: 0.001},

//     DOF:                             {type: 'separator' },
//     useDOF:                          {type: 'boolean' },
//     uBokehThreshold:                 {type: 'number', min: 0.0005, max: 2, step: 0.001 },
//     uBokehRadius:                    {type: 'number', min: 0.0005, max: 10, step: 0.001 },
//     uBokehAmount:                    {type: 'number', min: 0.0005, max: 4.0005, step: 0.001 },
//     uFocalDistance:                  {type: 'number', min: 0.0005, max: 1.0005, step: 0.0005 },
//     uAperture:                       {type: 'number', min: 0.0005, max: 10.0005, step: 0.001 },
// }



let guiOptions = {};




if (params.debug) {
    var gui = new DAT.GUI();
    let root = gui;
    for (let k in guiOptions) {
        if (guiOptions[k].type == 'separator')
            root = gui.addFolder( k );
        else if (guiOptions[k].type == 'number') {
            let p = root.add(params, k).min(guiOptions[k].min).max(guiOptions[k].max).step( guiOptions[k].step || 0.01 )
            if (guiOptions[k].onChange) {
                p.onChange( guiOptions[k].onChange )
            }
        }
        else {
            let p = root.add(params, k)
            if (guiOptions[k].onChange) {
                p.onChange( guiOptions[k].onChange )
            }
        }
    }
    gui.close()
}


export default params;




//TODO: auto clear ?
export var debugData =  {
    debugRenderPass: 'denoisedDiffuseIBLBufferRenderPass',
    renderPasses: [],
    // renderPasses: {
    //     d: {},
    //     push(pass) {
    //         this.d[ pass.name ] = pass;
    //     }
    // },
    cache: {
        programs: {},
        primitives: {},
    }
}
if (params.debug) {
    let gui = new DAT.GUI();
    gui.add(debugData, 'debugRenderPass', {
        shadowMapRenderPass: 'shadowMapRenderPass',
        VoxelRenderPass:         'VoxelRenderPass', 
        VoxelTextureRenderPass0: 'VoxelTextureRenderPass0', 
        VoxelTextureRenderPass1: 'VoxelTextureRenderPass1', 
        VoxelTextureRenderPass2: 'VoxelTextureRenderPass2', 
        ToneMappingRenderPass: 'ToneMappingRenderPass',
        specularIBLBufferRenderPass0: 'specularIBLBufferRenderPass0',
        denoisedDiffuseIBLBufferRenderPass: 'denoisedDiffuseIBLBufferRenderPass',
    } );
}

export var cache = {}


updateProfile( params, profile );

